import axios from '@/plugins/axios';

const BIDDING_HISTORY = 'bidding-history';
const ESTATES = '/estates';

export async function getListBiddingHistory(payload) {
  try {
    const { data } = await axios.get(`${ESTATES}/${payload.estate}/${BIDDING_HISTORY}`, { params: payload });
    return data;
  } catch (err) {
    return { err };
  }
}

export async function getListBiddingHistorySeller(payload) {
  try {
    const { data } = await axios.get(`${ESTATES}/${payload.estate}/seller/${BIDDING_HISTORY}`, { params: payload });
    return data;
  } catch (err) {
    return { err };
  }
}
